import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {  Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _moment from 'moment';
import {delay, map} from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import {AppComponent} from '../../app.component';
import { Classlibrary } from './classlibrary';
import { AlertService } from '../../alertpopup/_alert';
export interface Section {
  hdID: string;
  MainDescr: string;
}
export interface Users {
  id1: string;
  name: string;
}

@Component({
    selector: 'app-add-library',
    templateUrl: './add-library.component.html',
    styleUrls: ['./add-library.component.css'],
    standalone: false
})

export class AddLibraryComponent implements OnInit {

  url: string;
  DownloadURL: string;
  addLibraryEvent: FormGroup;
  id: any;
  numb: any;
  fileurls = [];
  dtColumns = [];
  fileSize: string;
  fileName: string;
  pageurl: string;
  editable: boolean;
  ProductHelpList: Section[] = [];
  UsersList: Users[]=[];
  selectedUsers=[];
  libraryDetail: any;
  selectedProduct: number;
  selectedCategory: number;
  selectedSubCategory: number;
  LibraryCategoryList: Section[] = [];
  LibrarySubCategoryList: Section[] = [];
  Company: any;
  Department: any;
  RightsID: string;
  RouteGMProduct: string;
  RouteGMLibCategory: string;
  RouteGMLibSubCategory: string;
  RouteCompany: string;
  RouteGMDepartment: string;
  RouteUserMaster: string;
  ButtonCaption: string;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, private sanitization: DomSanitizer, protected alertService: AlertService ) {
    this.url = AppComponent.baseURL; this.DownloadURL = AppComponent.DownloadURL;
  }

  ngOnInit() {
    this.RightsID = localStorage.getItem('UserRight');
    this.RouteUserMaster = this.RightsID.includes('202040000') || this.RightsID.includes('202040001') || this.RightsID.includes('202040021') ? '/user-master' : '/module/0';
    if (this.RightsID.includes('202028001') || this.RightsID.includes('202028021') || this.RightsID.includes('202028000')) {
  } else {
    window.location.href = "module/0";
  }
  this.RouteCompany = this.RightsID.includes('202044000') || this.RightsID.includes('202044001') || this.RightsID.includes('202044021') ? '/navcompany/company/0' : '/module/0';

    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.id = pagehead[2];

      // Set Validation for Fact Sheet Form
    this.addLibraryEvent = this.formBuilder.group({
      browseFiles: ['',Validators.required], fileDescription: [''], HelpProduct: [''], fileRef: [''], LibCategory: ['',Validators.required],
      LibSubCategory: ['',Validators.required], Company: ['',Validators.required], Department: ['',Validators.required],IsPublic: [''], ShareWithUser:[null] });
    this.addLibraryEvent.controls['browseFiles'].enable();
    this.addLibraryEvent.patchValue({ fileDescription: '', fileRef: '', Company: null, LibCategory: null, LibSubCategory: null,
    Department: null, HelpProduct: null, IsPublic: '1'});
    this.getMaster('075', '') .subscribe( (data: any) => {
      this.ProductHelpList = data;
     });
    this.getMaster('095', '') .subscribe( (data: any) => {
      this.LibraryCategoryList = data;
     });
     // 30= Department
     this.getMaster('030', '') .subscribe( (data: any) => {
      this.Department = data; });
        /********** For Get Compant Master Name List ****** */
        this.http.get(this.url + 'Notice/GetCompanyMasterList') .subscribe( (data) => {
          this.Company = JSON.parse(data.toString()); });
           /********** For Get Contact Manager Name ******  !isHidden */
    this.http.get(this.url + 'GM/GetEmployee') .subscribe( (data) => {
      this.UsersList = JSON.parse(data.toString());
    } );
    this.ButtonCaption = "Add";
    if (this.id > 0) {
      this.fetchLibraryDetail();
      this.ButtonCaption = "Update";
    }
    if (this.RightsID.includes('202042000') || this.RightsID.includes('202042001') || this.RightsID.includes('202042021')) {
      this.RouteGMProduct = "general-master/075";
      this.RouteGMLibCategory = "general-master/095";
      this.RouteGMLibSubCategory = "general-master/100";
      this.RouteGMDepartment = "/general-master/030";
      } else {
        this.RouteGMProduct = "module/0";
        this.RouteGMLibCategory = "module/0";
        this.RouteGMLibSubCategory = "module/0";
        this.RouteGMDepartment ="module/0";
      }
  }

  get f() { return this.addLibraryEvent.controls; }
  onCategorySelect(value) {
    this.getMaster('100', value.hdID).subscribe( (data: any) => {
        this.LibrarySubCategoryList = data; });
    }
  getMaster(GID: string, MID: string) {
    return this.http.get(this.url + 'GM/GetMaster?GenID=' + GID + '&MainID=' + MID)
    .pipe(map(data => data = (data == null ? null : JSON.parse(data.toString()))));
    }
    // For Get Fact Sheet Files in Base64 format
onSelectFile(event) {
  this.fileurls = [];
  this.fileName = '';
  this.fileSize = '';
  if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        this.fileName += event.target.files[i].name + ',';
        this.fileSize += event.target.files[i].size + ',';
        let reader = new FileReader();
        reader.onload = ( event: any) => { this.fileurls.push(event.target.result); };
        reader.readAsDataURL(event.target.files[i]);
      }
  }
}
onLibrarySubmit(LibraryFormData) {
  if (this.addLibraryEvent.invalid) { 
    this.addLibraryEvent.markAllAsTouched();  
    return;
  }
  if (this.id === 0) {
    if (!this.fileSize) {
      this.alertService.showWarning('Please Select File');
      return;
    }
  }
  this.numb = 1;
  let Classlibrary: Classlibrary = {
     id: this.id,
     fileSize: this.fileSize,
     fileBase: this.fileurls,
     fileName: this.fileName,
     description: LibraryFormData.fileDescription,
     fileRef: LibraryFormData.fileRef,
     product: LibraryFormData.HelpProduct,
     recAddUser: this.numb,
     contextID: this.numb,
     lbDate: '',
     LibraryCategory: LibraryFormData.LibCategory,
     LibrarySubCategory: LibraryFormData.LibSubCategory,
     LibraryCategoryID: LibraryFormData.LibCategory,
     LibrarySubCategoryID: LibraryFormData.LibSubCategory,
     CompanyID: LibraryFormData.Company,
     CompanyName: "",
     DepartmentID: LibraryFormData.Department,
     DepartmentName: "",
     IsPublic: LibraryFormData.IsPublic,
     ShareWithUser: LibraryFormData?.ShareWithUser?.toString(),
     ShareWithName: ""
    };
  this.http.post(this.url + 'dashboard/insertLibrary', Classlibrary) .subscribe( (data) =>  {
           if (data == null) {
            this.alertService.showError('Library Not Submitted');
           } else {
             if (this.id == 0 ) {
              this.alertService.showSuccess('Library Submited');
               this.addLibraryEvent.patchValue({fileDescription: '', fileRef: '', LibCategory: 0, LibSubCategory: 0, HelpProduct: 0});
            }
             if (this.id > 0) {
              this.alertService.showSuccess('Library Updated Successfully');
          }
           }
          }
        );
  }

  fetchLibraryDetail() {
      this.addLibraryEvent.controls['browseFiles'].disable();
      this.http.get(this.url + 'Dashboard/FetchLibraryRecord?ID=' + this.id)
    .subscribe( (data) => {
        if (data == null) {
          this.alertService.showError('No Data Found');
          }
        this.libraryDetail = JSON.parse(data.toString());
        let Classlibrary: Classlibrary = JSON.parse(data.toString())[0];
        if (Classlibrary.ShareWithUser != null  ) {
          // this.selectedSections = fetchHeaderdata.Section.toString().split('~').map(Number); }
        this.selectedUsers=Classlibrary.ShareWithUser.toString().split(',').map(Number);}
        this.addLibraryEvent.patchValue({ fileDescription: Classlibrary.description, fileRef: Classlibrary.fileRef,
          LibCategory: Classlibrary.LibraryCategoryID, HelpProduct: Classlibrary.product , Company: Classlibrary.CompanyID,
          Department:Classlibrary.DepartmentID, IsPublic:Classlibrary.IsPublic.toString(), ShareWithUser : Classlibrary.ShareWithUser.split(',').map(Number)
        });
        if (Classlibrary.LibraryCategoryID != null) {
            this.getMaster('100', Classlibrary.LibraryCategoryID.toString()).subscribe( (data: any) => {
              this.LibrarySubCategoryList = data ;
              this.addLibraryEvent.patchValue({ LibSubCategory: Classlibrary.LibrarySubCategoryID});
            }); }

      }
    );

  }
}
